/**
 * 
 * key
 * 
 */


const key = 'cGF5bWVudF90ZXJtcw=='

export default key 